import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { isInternalAllowlistedAccount } from '../constants/internalAllowlist'
import { useAppWeb3 } from '../hooks'

/**
 * Solo renderiza los hijos si la wallet conectada tiene internalRoutesEnabled vía API.
 * Si no hay cuenta o no está en la lista, redirige a la home.
 */
export default function AllowlistRouteGate({ children }: { children: ReactNode }) {
  const { account } = useAppWeb3()
  if (!isInternalAllowlistedAccount(account)) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
